import { render, staticRenderFns } from "./FilterSideBar.vue?vue&type=template&id=472c6a88&scoped=true&"
import script from "./FilterSideBar.vue?vue&type=script&lang=js&"
export * from "./FilterSideBar.vue?vue&type=script&lang=js&"
import style0 from "./FilterSideBar.vue?vue&type=style&index=0&id=472c6a88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472c6a88",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VDivider,VIcon,VNavigationDrawer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('472c6a88')) {
      api.createRecord('472c6a88', component.options)
    } else {
      api.reload('472c6a88', component.options)
    }
    module.hot.accept("./FilterSideBar.vue?vue&type=template&id=472c6a88&scoped=true&", function () {
      api.rerender('472c6a88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/equipment/components/FilterSideBar.vue"
export default component.exports